var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-wrapper"},[_c('notifications',{attrs:{"position":"bottom left"}}),_c('LoginDialog'),_c('LoadingDialog'),_c('MessageDialog'),_c('VDNavbar'),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }